export default __webpack_public_path__ + "static/media/walletconnect.03da5e3f.svg";